import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { convertUnit as r, lengthToDegrees as t } from "../core/unitUtils.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import o from "./Point.js";
import c from "./Polygon.js";
import { getReferenceEllipsoid as n } from "./projectionEllipsoid.js";
import { directGeodeticSolver as a } from "./support/geodesicUtils.js";
import { webMercatorToGeographic as p, geographicToWebMercator as l } from "./support/webMercatorUtils.js";
import u from "./support/WKIDUnitConversion.js";

var _d;

var h = _d = /*#__PURE__*/function (_c) {
  _inherits(d, _c);

  var _super = _createSuper(d);

  function d() {
    var _this;

    _classCallCheck(this, d);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.center = null, _this.geodesic = !1, _this.numberOfPoints = 60, _this.radius = 1e3, _this.radiusUnit = "meters";
    return _this;
  }

  _createClass(d, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e, r) {
      var t;
      if (e && e.center) t = e;else {
        if (e && e.rings) return _get(_getPrototypeOf(d.prototype), "normalizeCtorArgs", this).call(this, e, r);
        t = {
          center: e
        };
      }
      return _objectSpread(_objectSpread(_objectSpread({}, _get(_getPrototypeOf(d.prototype), "normalizeCtorArgs", this).call(this)), t), r);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var e = this.center,
          s = this.numberOfPoints;
      if (this.hasZ = e && e.hasZ, 0 !== this.rings.length || !e) return;
      var i = r(this.radius, this.radiusUnit, "meters"),
          o = e.spatialReference;
      var c,
          a = "geographic";

      if (o.isWebMercator ? a = "webMercator" : (null != u[o.wkid] || o.wkt && 0 === o.wkt.indexOf("PROJCS")) && (a = "projected"), this.geodesic) {
        var _r;

        switch (a) {
          case "webMercator":
            _r = p(e);
            break;

          case "projected":
            console.error("Creating a geodesic circle requires the center to be specified in web mercator or geographic coordinate system");
            break;

          case "geographic":
            _r = e;
        }

        c = this._createGeodesicCircle(_r, i, s), "webMercator" === a && (c = l(c));
      } else {
        var _r2;

        "webMercator" === a || "projected" === a ? _r2 = i / this._convert2Meters(1, e.spatialReference) : "geographic" === a && (_r2 = t(i, "meters", n(e.spatialReference).radius)), c = this._createPlanarCircle(e, _r2, s);
      }

      this.spatialReference = c.spatialReference, this.addRing(c.rings[0]);
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = this.center,
          r = this.numberOfPoints,
          t = this.radius,
          s = this.radiusUnit,
          i = this.geodesic;
      return new _d({
        center: e.clone(),
        numberOfPoints: r,
        radius: t,
        radiusUnit: s,
        geodesic: i
      });
    }
  }, {
    key: "_createGeodesicCircle",
    value: function _createGeodesicCircle(e, r, t) {
      var s = 0;
      var i = [];

      for (; s < 360;) {
        var _o = [0, 0],
            _c2 = [e.x, e.y];
        a(_o, _c2, s, r), this.hasZ && _o.push(e.z), i.push(_o), s += 360 / t;
      }

      return i.push(i[0]), new c(i);
    }
  }, {
    key: "_createPlanarCircle",
    value: function _createPlanarCircle(e, r, t) {
      var s = [],
          i = 2 * Math.PI / t;

      for (var _o2 = 0; _o2 < t; ++_o2) {
        var _t = i * _o2,
            _c3 = [e.x + Math.cos(-_t) * r, e.y + Math.sin(-_t) * r];

        this.hasZ && _c3.push(e.z), s.push(_c3);
      }

      return s.push(s[0]), new c({
        spatialReference: e.spatialReference,
        rings: [s]
      });
    }
  }, {
    key: "_convert2Meters",
    value: function _convert2Meters(e, r) {
      var t;
      if (null != u[r.wkid]) t = u.values[u[r.wkid]];else {
        var _e = r.wkt,
            _s = _e.lastIndexOf(",") + 1,
            _i = _e.lastIndexOf("]]");

        t = parseFloat(_e.substring(_s, _i));
      }
      return e * t;
    }
  }]);

  return d;
}(c);

e([s({
  type: o
})], h.prototype, "center", void 0), e([s()], h.prototype, "geodesic", void 0), e([s()], h.prototype, "numberOfPoints", void 0), e([s()], h.prototype, "radius", void 0), e([s()], h.prototype, "radiusUnit", void 0), h = _d = e([i("esri.geometry.Circle")], h);
var m = h;
export { m as default };